import { axiosApi } from 'shared/api/axios'

export const exportAnalytics = async () => {
    try {
        const response = await axiosApi.get<string>(
            `${process.env.API_BACKEND}/v1/counterparties/counterparty/export/analytics`,
            { responseType: 'blob' },
        )

        const blob = new Blob([response.data])
        const uri = window.URL.createObjectURL(blob)
        const filename = 'CRM_Analytics.xlsx'

        return {
            uri,
            blob,
            filename,
        }
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка')
    }
}
